import { createWebHistory, createRouter } from 'vue-router'
import systemRouter from './modules/system.js'
import testRouter from './modules/test.js'
import testConstantRouter from './modules/testConstant.js'
import reportRouter from './modules/report.js'
import productionRouter from './modules/production.js'
// 仓储管理模块的异步路由统一从这里接入。
import wmsRouter from './modules/wms.js'
import inspectionsRouter from './modules/inspections.js'
import purchasesRouter from './modules/purchases.js'
import defectRouter from './modules/defect.js'
import materialRouter from './modules/material.js'
import inspectionChecksRouter from './modules/inventorycheck.js'



import supplierRouter from './modules/supplier.js'
//静态routes
export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue'),
    meta: { label: '登录', requireAuth: false },
  },
  {
    path: "/:pathMatch(.*)*",
    meta: {
      title: "找不到此页面",
    },
    component: () => import("@/views/error/404.vue"),
  },
  {
    path: '/',
    component: () => import('@/layout/LayoutIndex.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/views/Home.vue'),
        name: 'Home',
        meta: { title: '首页', icon: 'user', affix: true, requireAuth: true }
      },
      {
        path: '/realtime-dashboard',
        component: () => import('@/views/dashboard/RealtimeDashboard.vue'),
        name: 'RealtimeDashboard',
        meta: { title: '实时大屏', icon: 'reportforms', requireAuth: true, breadcrumb: false }
      },
      //不需要权限管理的路由菜单在这里加入
      // {
      //   path: '/测试',
      //   component: () => import('@/views/Home.vue'),
      //   name: 'Test',
      //   meta: { title: '测试', icon: 'user', affix: true, requireAuth: false }
      // },


    ]
  },
  {
    path: '/system',
    component: () => import('@/layout/LayoutIndex.vue'),
    hidden: true,
    children: [
      {
        path: '/system/dict/:id',
        component: () => import('@/views/systembase/dict/DitIndex.vue'),
        name: 'dict',
        hidden: true,
        meta: { title: '字典数据', requireAuth: false }
      },
    ]
  },
  //静态路由, 可以不用菜单也跳转
  // {
  //   path: '/test',
  //   component: () => import('@/layout/LayoutIndex.vue'),
  //   children: [
  //     {
  //       path: '/test/testAddConstantRoutesAdd',
  //       component: () => import('@/views/test/testAddConstantRoutes/testAddConstantRoutesAdd.vue'),
  //       name: 'testAddConstantRoutesAdd',
  //       meta: { title: '测试菜单没有的页'}
  //     }

  //   ]
  // },
  //防止后面越来越多的静态路由, 所有把对应模块的静态路由放到一个对应的js中然后包含进来
  ...testConstantRouter,
  // {
  //   path: '/system1',
  //   component: () => import('@/layout/LayoutIndex.vue'),
  //   children: [
  //     {
  //       path: '/system/dict1/:id',
  //       component: () => import('@/views/systembase/dict/DitIndex.vue'),
  //       name: 'dict',
  //       meta: { title: '字典数据', requireAuth: false }
  //     },
  //   ]
  // },
  // {
  //     path: '/system',
  //     component: () => import('@/layout/LayoutIndex.vue'),
  //     meta: { title: '系统管理', icon: 'system', requireAuth: true },
  //     name: 'system',
  //     redirect: '/home',
  //     children: [
  //     {
  //       path: '/system/modules',
  //       component: () => import('@/views/systembase/modules/ModuleIndex.vue'),
  //       name: 'modules',
  //       meta: { title: '模块管理', requireAuth: false }
  //     },
  //     {
  //       path: '/system/role',
  //       component: () => import('@/views/systembase/role/RoleIndex.vue'),
  //       name: 'role',
  //       meta: { title: '角色管理', requireAuth: false }
  //     },
  //     {
  //       path: '/system/dictType',
  //       component: () => import('@/views/systembase/dictType/DictTypeIndex.vue'),
  //       name: 'dictType',
  //       meta: { title: '字典管理', requireAuth: true }
  //     },
  //   ]
  // },

]

// 权限表

// 权限路由
export const asyncRoutes = [
  ...systemRouter,
  ...testRouter,
  ...reportRouter,
  ...productionRouter,
  // 仓储管理相关页面（如库位管理）通过该模块注入。
  ...materialRouter,
  ...wmsRouter,
  ...supplierRouter,
  ...defectRouter,
  ...inspectionsRouter,//检测管理
  ...purchasesRouter,//采购管理
  ...inspectionChecksRouter,//其他(盘点管理)
  // ...safeRouter,
  // ...skillRouter,
  // ...unsafeBehaviorRouter,
  // ...reportFormsRouter,
  // ...dangerRouter,
]

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
});

export default router;
